// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deal-forecast-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.deal-forecast-card .deal-forecast-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.deal-forecast-card .deal-forecast-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}
.deal-forecast-card .deal-forecast-header .menu-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #64748b;
  cursor: pointer;
  padding: 4px 8px;
}
.deal-forecast-card .deal-forecast-header .menu-btn:hover {
  color: #1e293b;
}
.deal-forecast-card .total-value {
  font-size: 48px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 32px;
  line-height: 1;
}
.deal-forecast-card .loading-spinner,
.deal-forecast-card .no-data {
  text-align: center;
  padding: 40px;
  color: #64748b;
}
.deal-forecast-card .stacked-bar-section .stage-values {
  display: flex;
  margin-bottom: 8px;
}
.deal-forecast-card .stacked-bar-section .stage-values .stage-value {
  font-size: 17px;
  font-weight: 500;
  color: #000000;
  text-align: center;
  padding: 0 4px;
}
.deal-forecast-card .stacked-bar-section .stage-values .stage-value:first-child {
  text-align: left;
}
.deal-forecast-card .stacked-bar-section .stage-values .stage-value:last-child {
  text-align: right;
}
.deal-forecast-card .stacked-bar-section .stacked-progress-bar {
  display: flex;
  width: 100%;
  height: 16px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
  background-color: #f1f5f9;
}
.deal-forecast-card .stacked-bar-section .stacked-progress-bar .progress-segment {
  height: 100%;
  transition: width 0.5s ease;
}
.deal-forecast-card .stacked-bar-section .stacked-progress-bar .progress-segment:first-child {
  border-radius: 8px 0 0 8px;
}
.deal-forecast-card .stacked-bar-section .stacked-progress-bar .progress-segment:last-child {
  border-radius: 0 8px 8px 0;
}
.deal-forecast-card .stacked-bar-section .stacked-progress-bar .progress-segment:only-child {
  border-radius: 8px;
}
.deal-forecast-card .stacked-bar-section .stage-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
}
.deal-forecast-card .stacked-bar-section .stage-labels .stage-label {
  display: flex;
  align-items: center;
  gap: 8px;
}
.deal-forecast-card .stacked-bar-section .stage-labels .stage-label .bar-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}
.deal-forecast-card .stacked-bar-section .stage-labels .stage-label .stage-name {
  font-size: 14px;
  color: #64748b;
}
@media (max-width: 768px) {
  .deal-forecast-card {
    padding: 16px;
  }
  .deal-forecast-card .total-value {
    font-size: 36px;
    margin-bottom: 24px;
  }
  .deal-forecast-card .stacked-bar-section .stage-values .stage-value {
    font-size: 12px;
  }
  .deal-forecast-card .stacked-bar-section .stacked-progress-bar {
    height: 12px;
  }
  .deal-forecast-card .stacked-bar-section .stage-labels {
    gap: 12px;
  }
  .deal-forecast-card .stacked-bar-section .stage-labels .stage-label .bar-indicator {
    width: 10px;
    height: 10px;
  }
  .deal-forecast-card .stacked-bar-section .stage-labels .stage-label .stage-name {
    font-size: 13px;
  }
}

.equal-height-box {
  display: flex;
}

.equal-height-box > div {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

/* Make all DealForecast wrapper boxes equal height */
.deal-forecast-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Force DealForecast card inside to stretch full height */
.deal-forecast-wrapper > div {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.equal-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.equal-card > * {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.deal-forecast-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Title + count alignment */
.deal-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.total-count-circle {
  width: 35px;
  height: 35px;
  background-color: #dceafe;
  color: #1D4ED8;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-card-gap {
  margin-bottom: 2px;
}
.dashboard-card-gap.card-left {
  margin-right: 8px;
}
.dashboard-card-gap.card-right {
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/Components/HorizontalBarChart/HorizontalBarChart.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AACN;AAEI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAAN;AAEM;EACE,cAAA;AAAR;AAKE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AAHJ;AAME;;EAEE,kBAAA;EACA,aAAA;EACA,cAAA;AAJJ;AAQI;EACE,aAAA;EACA,kBAAA;AANN;AAQM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AANR;AAQQ;EACE,gBAAA;AANV;AASQ;EACE,iBAAA;AAPV;AAYI;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAVN;AAYM;EACE,YAAA;EACA,2BAAA;AAVR;AAYQ;EACE,0BAAA;AAVV;AAaQ;EACE,0BAAA;AAXV;AAcQ;EACE,kBAAA;AAZV;AAiBI;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAfN;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAfR;AAiBQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAfV;AAkBQ;EACE,eAAA;EACA,cAAA;AAhBV;AAsBE;EA1HF;IA2HI,aAAA;EAnBF;EAqBE;IACE,eAAA;IACA,mBAAA;EAnBJ;EAwBM;IACE,eAAA;EAtBR;EA0BI;IACE,YAAA;EAxBN;EA2BI;IACE,SAAA;EAzBN;EA4BQ;IACE,WAAA;IACA,YAAA;EA1BV;EA6BQ;IACE,eAAA;EA3BV;AACF;;AAmCA;EACE,aAAA;AAhCF;;AAmCA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAhCF;;AAoCA,qDAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAjCF;;AAoCA,0DAAA;AACA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAjCF;;AAqCA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAlCF;AAoCE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAlCJ;;AAuCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AApCF;;AAuCA,4BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AApCF;;AAuCA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApCF;;AAuCA;EAKE,kBAAA;AAxCF;AA2CE;EACE,iBAAA;AArCJ;AAyCE;EACE,gBAAA;AAvCJ","sourcesContent":[".deal-forecast-card {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .deal-forecast-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n\n    h3 {\n      font-size: 18px;\n      font-weight: 600;\n      color: #1e293b;\n      margin: 0;\n    }\n\n    .menu-btn {\n      background: none;\n      border: none;\n      font-size: 20px;\n      color: #64748b;\n      cursor: pointer;\n      padding: 4px 8px;\n\n      &:hover {\n        color: #1e293b;\n      }\n    }\n  }\n\n  .total-value {\n    font-size: 48px;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 32px;\n    line-height: 1;\n  }\n\n  .loading-spinner,\n  .no-data {\n    text-align: center;\n    padding: 40px;\n    color: #64748b;\n  }\n\n  .stacked-bar-section {\n    .stage-values {\n      display: flex;\n      margin-bottom: 8px;\n\n      .stage-value {\n        font-size: 17px;\n        font-weight: 500;\n        color: #000000;\n        text-align: center;\n        padding: 0 4px;\n        \n        &:first-child {\n          text-align: left;\n        }\n        \n        &:last-child {\n          text-align: right;\n        }\n      }\n    }\n\n    .stacked-progress-bar {\n      display: flex;\n      width: 100%;\n      height: 16px;\n      border-radius: 8px;\n      overflow: hidden;\n      margin-bottom: 16px;\n      background-color: #f1f5f9;\n\n      .progress-segment {\n        height: 100%;\n        transition: width 0.5s ease;\n\n        &:first-child {\n          border-radius: 8px 0 0 8px;\n        }\n\n        &:last-child {\n          border-radius: 0 8px 8px 0;\n        }\n\n        &:only-child {\n          border-radius: 8px;\n        }\n      }\n    }\n\n    .stage-labels {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 16px;\n      margin-top: 16px;\n\n      .stage-label {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        .bar-indicator {\n          width: 12px;\n          height: 12px;\n          border-radius: 50%;\n          flex-shrink: 0;\n        }\n\n        .stage-name {\n          font-size: 14px;\n          color: #64748b;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 16px;\n\n    .total-value {\n      font-size: 36px;\n      margin-bottom: 24px;\n    }\n\n    .stacked-bar-section {\n      .stage-values {\n        .stage-value {\n          font-size: 12px;\n        }\n      }\n\n      .stacked-progress-bar {\n        height: 12px;\n      }\n\n      .stage-labels {\n        gap: 12px;\n\n        .stage-label {\n          .bar-indicator {\n            width: 10px;\n            height: 10px;\n          }\n\n          .stage-name {\n            font-size: 13px;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n.equal-height-box {\n  display: flex;\n}\n\n.equal-height-box > div {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n\n/* Make all DealForecast wrapper boxes equal height */\n.deal-forecast-wrapper {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Force DealForecast card inside to stretch full height */\n.deal-forecast-wrapper > div {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n\n.equal-card {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  > * {\n    flex: 1;         // Force DealForecast to fill same height\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n\n.deal-forecast-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Title + count alignment */\n.deal-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.total-count-circle {\n  width: 35px;\n  height: 35px;\n  background-color: #dceafe;\n  color: #1D4ED8;                \n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n}\n.dashboard-card-gap {\n  margin-bottom: 2px;\n}\n\n.dashboard-card-gap {\n  margin-bottom: 2px;  // your existing style\n\n  // Add right spacing for left-column cards\n  &.card-left {\n    margin-right: 8px;\n  }\n\n  // Add left spacing for right-column cards\n  &.card-right {\n    margin-left: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
